class FacetFiltersForm extends HTMLElement {
  static sizeQuickFilterShineStorageKey = 'facet_size_quick_filter_shine_dismissed';
  static featuresQuickFilterShineStorageKey = 'facet_features_quick_filter_shine_dismissed';
  static sizeQuickFilterShinePlayedThisPage = false;
  static featuresQuickFilterShinePlayedThisPage = false;
  static get observedAttributes() {
    return ['selected-index'];
  }
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);
    this.onQuickFilterClick = this.onQuickFilterClick.bind(this);
    this.onSingleSelectFilterChange = this.onSingleSelectFilterChange.bind(this);

    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 500);

    this.querySelector('form').addEventListener('input', this.debouncedOnSubmit.bind(this));
    this.querySelector('form').addEventListener('change', this.onSingleSelectFilterChange);
    this.addEventListener('click', this.onQuickFilterClick);
    FacetFiltersForm.normalizePlantSizeQuickFilterButtons(window.location.search.slice(1));
    FacetFiltersForm.syncSizeQuickFilterShineState();
    FacetFiltersForm.syncFeaturesQuickFilterShineState();
  }
  get selectedIndex() {
    return parseInt(this.getAttribute('selected-index')) || 0;
  }
  set selectedIndex(index) {
    this.setAttribute('selected-index', index);
  }
  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    };
    window.addEventListener('popstate', onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable);
    });
  }

  static toggleActiveTabs() {
    document.querySelectorAll('.facets-popup-modal--tabs-button').forEach((element, i) => {
      element.classList.toggle('active', i == FacetFiltersForm.selectedIndex);
    });
    document.querySelectorAll('.facets-popup-modal--tab').forEach((element, i) => {
      element.classList.toggle('active', i == FacetFiltersForm.selectedIndex);
    });
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    searchParams = FacetFiltersForm.normalizePlantSizeSearchParams(searchParams);
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();
    const container = document.getElementsByClassName('thb-filter-count');
    document.getElementById('ProductGridContainer').querySelector('.collection').classList.add('loading');

    for (var item of container) {
      item.classList.add('loading');
    }

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = element => element.url === url;

      if (FacetFiltersForm.filterData.some(filterDataUrl)) {
        FacetFiltersForm.renderSectionFromCache(filterDataUrl, event);
      } else {
        FacetFiltersForm.renderSectionFromFetch(url, event);
      }
    });
    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
  }

  static normalizePlantSizeSearchParams(searchParams) {
    const params = new URLSearchParams(typeof searchParams === 'string' ? searchParams : '');
    const plantSizeParamNames = Array.from(new Set(Array.from(params.keys()).filter((key) => key.includes('plant_size'))));

    plantSizeParamNames.forEach((paramName) => {
      const values = params.getAll(paramName);
      if (values.length <= 1) return;

      const keepValue = values[values.length - 1];
      params.delete(paramName);
      params.append(paramName, keepValue);
    });

    return params.toString();
  }

  static normalizeFilterValue(value) {
    return String(value || '').trim().toLowerCase();
  }

  static hasDismissedSizeQuickFilterShine() {
    try {
      return window.localStorage.getItem(FacetFiltersForm.sizeQuickFilterShineStorageKey) === '1';
    } catch (error) {
      return false;
    }
  }

  static dismissSizeQuickFilterShine() {
    try {
      window.localStorage.setItem(FacetFiltersForm.sizeQuickFilterShineStorageKey, '1');
    } catch (error) {
      // Ignore storage failures (private mode, blocked storage, etc.).
    }
    FacetFiltersForm.syncSizeQuickFilterShineState();
  }

  static clearSizeQuickFilterShineDismissal() {
    try {
      window.localStorage.removeItem(FacetFiltersForm.sizeQuickFilterShineStorageKey);
    } catch (error) {
      // Ignore storage failures (private mode, blocked storage, etc.).
    }
  }

  static hasDismissedFeaturesQuickFilterShine() {
    try {
      return window.localStorage.getItem(FacetFiltersForm.featuresQuickFilterShineStorageKey) === '1';
    } catch (error) {
      return false;
    }
  }

  static dismissFeaturesQuickFilterShine() {
    try {
      window.localStorage.setItem(FacetFiltersForm.featuresQuickFilterShineStorageKey, '1');
    } catch (error) {
      // Ignore storage failures (private mode, blocked storage, etc.).
    }
    FacetFiltersForm.syncFeaturesQuickFilterShineState();
  }

  static clearFeaturesQuickFilterShineDismissal() {
    try {
      window.localStorage.removeItem(FacetFiltersForm.featuresQuickFilterShineStorageKey);
    } catch (error) {
      // Ignore storage failures (private mode, blocked storage, etc.).
    }
  }

  static hasActiveSizeQuickFilterSelection() {
    return !!document.querySelector('.facets-size-inline__button.active');
  }

  static hasActiveFeaturesQuickFilterSelection() {
    return !!document.querySelector('.facets-features-inline__button.active');
  }

  static syncSizeQuickFilterShineState() {
    const hasActiveSizeSelection = FacetFiltersForm.hasActiveSizeQuickFilterSelection();
    const shouldShine = !hasActiveSizeSelection
      && !FacetFiltersForm.hasDismissedSizeQuickFilterShine()
      && !FacetFiltersForm.sizeQuickFilterShinePlayedThisPage;

    if (shouldShine) {
      FacetFiltersForm.sizeQuickFilterShinePlayedThisPage = true;
    }

    document.querySelectorAll('.facets-size-inline__list').forEach((list) => {
      list.classList.toggle('facets-size-inline__list--shine-on-load', shouldShine);
    });
  }

  static syncFeaturesQuickFilterShineState() {
    const hasActiveFeaturesSelection = FacetFiltersForm.hasActiveFeaturesQuickFilterSelection();
    const shouldShine = !hasActiveFeaturesSelection
      && !FacetFiltersForm.hasDismissedFeaturesQuickFilterShine()
      && !FacetFiltersForm.featuresQuickFilterShinePlayedThisPage;

    if (shouldShine) {
      FacetFiltersForm.featuresQuickFilterShinePlayedThisPage = true;
    }

    document.querySelectorAll('.facets-features-inline__list').forEach((list) => {
      list.classList.toggle('facets-features-inline__list--shine-on-load', shouldShine);
    });
  }

  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then(response => response.text())
      .then((responseText) => {
        const html = responseText;
        FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, {
          html,
          url
        }];
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html);
        FacetFiltersForm.renderProductCount(html);

      });
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
    FacetFiltersForm.renderProductCount(html);
  }

  static renderProductGridContainer(html) {
    document.getElementById('ProductGridContainer').innerHTML = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductGridContainer').innerHTML;

    ScrollTrigger.batch('.animations-true .product-card .product-featured-image-link, .animations-true .products .gallery--item figure', {
      start: "top 90%",
      onEnter: (elements, triggers) => {
        gsap.to(elements, { scale: 1, opacity: 1, stagger: 0.15, ease: window.theme.settings.animation_easing });
      }
    });

    document.getElementById('Facets-Toggle-Fixed')?.setElements();
  }

  static renderProductCount(html) {
    const countHtml = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductCount');
    const container = document.getElementsByClassName('thb-filter-count');

    if (countHtml) {
      for (var item of container) {
        item.innerHTML = countHtml.innerHTML;
        item.classList.remove('loading');
      }
    }

  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');

    const facetDetailsElements = parsedHTML.querySelectorAll('#FacetsModal-inner .facets-popup-modal--tab');
    const matchesIndex = (element) => {
      const jsFilter = event ? event.target.closest('.facets-popup-modal--tab') : undefined;
      return jsFilter ? element.dataset.index === jsFilter.dataset.index : false;
    };
    const facetsToRender = Array.from(facetDetailsElements).filter(element => !matchesIndex(element));

    facetsToRender.forEach((element) => {
      const currentTab = document.querySelector(`.facets-popup-modal--tab[data-index="${element.dataset.index}"]`);
      if (!currentTab) return;
      currentTab.innerHTML = element.innerHTML;
    });

    FacetFiltersForm.renderTabs(parsedHTML);
    FacetFiltersForm.renderActiveFacets(parsedHTML);
    FacetFiltersForm.renderAdditionalElements(parsedHTML);

    if (typeof SelectWidth !== 'undefined') {
      new SelectWidth();
    }
  }

  static renderTabs(html) {
    const tabSelectors = ['#FacetsModal-inner .facets-popup-modal--tabs, #FacetsModal-inner .facets-popup-modal__content-info'];

    tabSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      const currentElement = document.querySelector(selector);
      if (!activeFacetsElement || !currentElement) return;
      currentElement.innerHTML = activeFacetsElement.innerHTML;
    });

    FacetFiltersForm.toggleActiveTabs();
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = ['.active-facets'];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      const currentElement = document.querySelector(selector);
      if (!activeFacetsElement || !currentElement) return;
      currentElement.innerHTML = activeFacetsElement.innerHTML;
    });

    FacetFiltersForm.toggleActiveFacets(false);
  }

  static renderAdditionalElements(html) {
    const facetButtons = ['#Facets-Toggle', '#Facets-Toggle-Fixed', '#FacetFiltersForm-buttons', '.thb-filter-sort-count--bar', '.thb-filter-sort-count--modal'];

    facetButtons.forEach((selector) => {
      const nextElement = html.querySelector(selector);
      const currentElement = document.querySelector(selector);
      if (!nextElement || !currentElement) return;
      currentElement.innerHTML = nextElement.innerHTML;
    });

    FacetFiltersForm.normalizePlantSizeQuickFilterButtons(FacetFiltersForm.searchParamsPrev || window.location.search.slice(1));
    FacetFiltersForm.syncSizeQuickFilterShineState();
    FacetFiltersForm.syncFeaturesQuickFilterShineState();
  }

  static normalizePlantSizeQuickFilterButtons(searchParamsOverride = '') {
    const buttons = Array.from(document.querySelectorAll('.facets-size-inline__button[data-filter-param][data-filter-value]'));
    if (!buttons.length) return;

    const baseSearch = searchParamsOverride || window.location.search.slice(1);
    const currentSearch = FacetFiltersForm.normalizePlantSizeSearchParams(baseSearch);
    const groupedButtons = {};

    buttons.forEach((button) => {
      const paramName = button.dataset.filterParam;
      if (!paramName) return;
      if (!groupedButtons[paramName]) groupedButtons[paramName] = [];
      groupedButtons[paramName].push(button);
    });

    Object.keys(groupedButtons).forEach((paramName) => {
      const currentParams = new URLSearchParams(currentSearch);
      const activeValues = currentParams.getAll(paramName);
      const activeValue = activeValues.length ? activeValues[activeValues.length - 1] : null;
      const normalizedActiveValue = FacetFiltersForm.normalizeFilterValue(activeValue);

      groupedButtons[paramName].forEach((button) => {
        const buttonValue = button.dataset.filterValue;
        const normalizedButtonValue = FacetFiltersForm.normalizeFilterValue(buttonValue);
        const isActive = !!normalizedActiveValue && normalizedButtonValue === normalizedActiveValue;
        button.classList.toggle('active', isActive);

        const nextParams = new URLSearchParams(currentSearch);
        nextParams.delete(paramName);
        if (!isActive && buttonValue) {
          nextParams.append(paramName, buttonValue);
        }

        const nextSearch = FacetFiltersForm.normalizePlantSizeSearchParams(nextParams.toString());
        button.href = `${window.location.pathname}${nextSearch ? `?${nextSearch}` : ''}`;
      });
    });
  }

  static updateURLHash(searchParams) {
    history.pushState({
      searchParams
    }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
  }

  static getSections() {
    return [
      {
        section: document.getElementById('product-grid').dataset.id,
      }];
  }

  onSubmitHandler(event) {
    event.preventDefault();
    const formData = new FormData(event.target.closest('form'));
    const searchParams = new URLSearchParams(formData);
    this.enforcePlantSizeSingleSelection(searchParams);


    if (searchParams.get('filter.v.price.gte') === "0.00") {
      searchParams.delete('filter.v.price.gte');
    }
    if (document.querySelector('.price_slider')) {
      if (searchParams.get('filter.v.price.lte') === parseFloat(document.querySelector('.price_slider').dataset.max).toFixed(2)) {
        searchParams.delete('filter.v.price.lte');
      }
    }
    FacetFiltersForm.renderPage(searchParams.toString(), event);
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    const url = event.currentTarget.href.indexOf('?') == -1 ? '' : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
    const normalizedUrl = FacetFiltersForm.normalizePlantSizeSearchParams(url);
    const nextParams = new URLSearchParams(normalizedUrl);
    const hasPlantSizeSelection = Array.from(nextParams.keys()).some((key) => key.includes('plant_size'));
    if (!hasPlantSizeSelection) {
      FacetFiltersForm.clearSizeQuickFilterShineDismissal();
    }

    // If no filter params remain (clear all), allow feature shine again.
    if (Array.from(nextParams.keys()).filter((key) => key !== 'sort_by').length === 0) {
      FacetFiltersForm.clearFeaturesQuickFilterShineDismissal();
    }
    FacetFiltersForm.renderPage(normalizedUrl);
  }
  onQuickFilterClick(event) {
    const quickFilterLink = event.target.closest('.facets-quick-filter__button');

    if (!quickFilterLink || quickFilterLink.classList.contains('disabled')) {
      return;
    }

    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();

    let url = quickFilterLink.href.indexOf('?') == -1 ? '' : quickFilterLink.href.slice(quickFilterLink.href.indexOf('?') + 1);

    // Plant Size quick filter should behave like radio (single selection only).
    if (quickFilterLink.classList.contains('facets-size-inline__button')) {
      const paramName = quickFilterLink.dataset.filterParam;
      const paramValue = quickFilterLink.dataset.filterValue;
      const normalizedCurrentSearch = FacetFiltersForm.normalizePlantSizeSearchParams(window.location.search.slice(1));
      const searchParams = new URLSearchParams(normalizedCurrentSearch);
      const activeValue = paramName ? searchParams.get(paramName) : null;
      const isCurrentlyActive = !!paramName && FacetFiltersForm.normalizeFilterValue(activeValue) === FacetFiltersForm.normalizeFilterValue(paramValue);

      if (paramName) {
        searchParams.delete(paramName);

        if (!isCurrentlyActive && paramValue) {
          searchParams.append(paramName, paramValue);
          FacetFiltersForm.dismissSizeQuickFilterShine();
        } else {
          FacetFiltersForm.clearSizeQuickFilterShineDismissal();
        }
        this.enforcePlantSizeSingleSelection(searchParams);
        url = searchParams.toString();
        FacetFiltersForm.normalizePlantSizeQuickFilterButtons(url);
      }
    }

    if (quickFilterLink.classList.contains('facets-features-inline__button')) {
      const isCurrentlyActive = quickFilterLink.classList.contains('active');
      if (!isCurrentlyActive) {
        FacetFiltersForm.dismissFeaturesQuickFilterShine();
      } else {
        FacetFiltersForm.clearFeaturesQuickFilterShineDismissal();
      }
    }

    FacetFiltersForm.renderPage(url);
  }

  onSingleSelectFilterChange(event) {
    const input = event.target;
    if (!input || input.type !== 'checkbox') return;
    if (input.dataset.singleSelectGroup !== 'plant-size') return;
    if (!input.checked) return;

    this.querySelectorAll('input[type="checkbox"][data-single-select-group="plant-size"]').forEach((checkbox) => {
      if (checkbox !== input && checkbox.name === input.name) checkbox.checked = false;
    });
  }

  enforcePlantSizeSingleSelection(searchParams) {
    if (!searchParams || typeof searchParams.getAll !== 'function') return;

    const configuredParamNames = Array.from(
      new Set(
        Array.from(document.querySelectorAll('.facets-size-inline__button[data-filter-param]'))
          .map((button) => button.dataset.filterParam)
          .filter(Boolean)
      )
    );
    const fallbackParamNames = Array.from(new Set(Array.from(searchParams.keys()).filter((key) => key.includes('plant_size'))));
    const targetParamNames = Array.from(new Set([...configuredParamNames, ...fallbackParamNames]));

    targetParamNames.forEach((paramName) => {
      const values = searchParams.getAll(paramName);
      if (values.length <= 1) return;

      const lastSelectedValue = values[values.length - 1];
      searchParams.delete(paramName);
      searchParams.append(paramName, lastSelectedValue);
    });
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();


class FacetRemove extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll('a').forEach((item) => {
      item.addEventListener('click', (event) => {
        event.preventDefault();
        const form = this.closest('facet-filters-form');
        form.onActiveFilterClick(event);
      });
    });
  }
}

customElements.define('facet-remove', FacetRemove);

/**
 *  @class
 *  @function PriceSlider
 */
class PriceSlider extends HTMLElement {

  constructor() {
    super();
  }
  connectedCallback() {
    let slider = this.querySelector('.price_slider'),
      amounts = this.querySelector('.price_slider_amount'),
      args = {
        start: [parseFloat(slider.dataset.minValue || 0), parseFloat(slider.dataset.maxValue || slider.dataset.max)],
        connect: true,
        step: 10,
        direction: document.dir,
        handleAttributes: [
          { 'aria-label': 'lower' },
          { 'aria-label': 'upper' },
        ],
        range: {
          'min': 0,
          'max': parseFloat(slider.dataset.max)
        }
      },
      event = new CustomEvent('input'),
      form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');

    if (!slider || !amounts || !form) return;

    // Guard against timing issues where noUiSlider script hasn't loaded yet.
    if (typeof noUiSlider === 'undefined' || typeof noUiSlider.create !== 'function') {
      if (!this.dataset.sliderRetryScheduled) {
        this.dataset.sliderRetryScheduled = 'true';
        setTimeout(() => {
          delete this.dataset.sliderRetryScheduled;
          if (this.isConnected) this.connectedCallback();
        }, 300);
      }
      return;
    }

    if (slider.classList.contains('noUi-target')) {
      slider.noUiSlider.destroy();
    }
    noUiSlider.create(slider, args);

    slider.noUiSlider.on('update', function (values) {
      amounts.querySelector('.field__input_min').value = values[0];
      amounts.querySelector('.field__input_max').value = values[1];
    });
    slider.noUiSlider.on('change', function (values) {
      form.querySelector('form').dispatchEvent(event);
    });
  }
}
customElements.define('price-slider', PriceSlider);


/**
 *  @class
 *  @function FacetsButtons
 */
if (!customElements.get('facet-buttons')) {
  class FacetButtons extends HTMLElement {
    constructor() {
      super();

    }
    connectedCallback() {
      this.setupObservers();

      this.debouncedOnDom = debounce((event) => {
        this.setupObservers();
      }, 500);

      var observer = new MutationObserver(this.debouncedOnDom.bind(this));
      observer.observe(this, { childList: true });
    }
    setupObservers() {
      this.buttons = this.querySelectorAll('button');
      this.drawer = document.getElementById(this.dataset.target);
      this.links = this.drawer.querySelectorAll('.facets-popup-modal--tabs-button');
      this.panels = this.drawer.querySelectorAll('.facets-popup-modal--tab');

      this.buttons.forEach((item, i) => {
        item.addEventListener('click', (e) => this.onClick(e, i));
      });
      this.links.forEach((item, i) => {
        item.addEventListener('click', (e) => this.onClick(e, i));
      });
    }
    onClick(e, i) {

      this.links.forEach((link) => {
        link.classList.remove('active');
      });
      this.links[i].classList.add('active');

      this.panels.forEach((panel) => {
        panel.classList.remove('active');
      });
      this.panels[i].classList.add('active');

      FacetFiltersForm.selectedIndex = i;
      e.preventDefault();
    }
  }

  customElements.define('facet-buttons', FacetButtons);
}

/**
 *  @class
 *  @function FacetToggle
 */
if (!customElements.get('facet-toggle')) {
  class FacetToggle extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      this.setElements();
      this.addEventListener('click', this.onClick.bind(this));
      this.setupObservers();
    }
    disconnectedCallback() {
      this.observer.unobserve(this.wrapper);
    }
    setupObservers() {
      window.addEventListener('scroll', this.onScroll.bind(this));
    }
    setElements() {
      this.drawer = document.getElementById(this.dataset.target);
      this.wrapper = this.closest('.collection-container').querySelector('#product-grid');
      this.form = this.closest('#FacetFiltersForm');
    }
    onClick() {
      this.drawer.show();
    }
    onScroll() {
      let total = this.wrapper.offsetTop + this.wrapper.offsetHeight - window.innerHeight + 90;
      if (window.scrollY < this.wrapper.offsetTop) {
        this.classList.remove('sticky');
      } else if (window.scrollY > this.wrapper.offsetTop && window.scrollY < total) {
        this.classList.add('sticky');
      } else if (window.scrollY >= total) {
        this.classList.remove('sticky');
      }
    }
  }

  customElements.define('facet-toggle', FacetToggle);
}
